<form [formGroup]="notificationEmailForm" class="notification-email-form">
    <div>
        <form-label [for]="'email'" [label]="subtitle(1110)"></form-label>
        <form-email-input [emailControl]="notificationEmailControl"></form-email-input>
    </div>
    <form-action-buttons>
        <form-button [subtitle]="subtitle(71)"
                     [btnType]="'cancel'"
                     (click)="closeForm()">
        </form-button>
        <form-button [subtitle]="subtitle(1255)"
                     [btnType]="'confirm'"
                     (click)="changeNotificationEmail()">
        </form-button>
    </form-action-buttons>
</form>
